var _style, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    color: "#262A3E",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.settings-svg{fill:none;stroke:currentColor;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "settings-svg",
    d: "M9.1,1.6c-0.1-0.5-0.5-0.9-1-0.9H7.9c-0.5,0-0.9,0.4-1,0.9L6.8,2.2C6.7,2.6,6.4,3,6.1,3.1C6,3.1,6,3.2,5.9,3.2 C5.5,3.4,5.1,3.3,4.8,3.1L4.5,2.9C4.1,2.6,3.5,2.6,3.1,3L3,3.1C2.6,3.5,2.6,4.1,2.9,4.5l0.2,0.3c0.2,0.3,0.3,0.8,0.1,1.1 c0,0.1,0,0.1-0.1,0.2C3,6.4,2.6,6.7,2.2,6.8L1.6,6.9c-0.5,0.1-0.9,0.5-0.9,1v0.3c0,0.5,0.4,0.9,0.9,1l0.6,0.1C2.6,9.3,3,9.6,3.1,9.9 c0,0.1,0,0.1,0.1,0.2c0.2,0.4,0.1,0.8-0.1,1.1l-0.2,0.3c-0.3,0.4-0.3,1,0.1,1.3L3.1,13c0.4,0.4,0.9,0.4,1.3,0.1l0.3-0.2 c0.3-0.2,0.8-0.3,1.1-0.1c0.1,0,0.1,0,0.2,0.1c0.4,0.2,0.7,0.5,0.7,0.9l0.1,0.6c0.1,0.5,0.5,0.9,1,0.9h0.3c0.5,0,0.9-0.4,1-0.9 l0.1-0.6c0.1-0.4,0.4-0.7,0.7-0.9c0.1,0,0.1,0,0.2-0.1c0.4-0.2,0.8-0.1,1.1,0.1l0.3,0.2c0.4,0.3,1,0.3,1.3-0.1l0.2-0.2 c0.4-0.4,0.4-0.9,0.1-1.3l-0.2-0.3c-0.2-0.3-0.3-0.8-0.1-1.1c0-0.1,0-0.1,0.1-0.2c0.2-0.4,0.5-0.7,0.9-0.7l0.6-0.1 c0.5-0.1,0.9-0.5,0.9-1V7.9c0-0.5-0.4-0.9-0.9-1l-0.6-0.1c-0.4-0.1-0.7-0.4-0.9-0.7c0-0.1,0-0.1-0.1-0.2c-0.2-0.4-0.1-0.8,0.1-1.1 l0.2-0.3c0.3-0.4,0.3-1-0.1-1.3L12.9,3c-0.4-0.4-0.9-0.4-1.3-0.1l-0.3,0.2c-0.3,0.2-0.8,0.3-1.1,0.1c-0.1,0-0.1,0-0.2-0.1 C9.6,3,9.3,2.6,9.2,2.2L9.1,1.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "settings-svg",
    d: "M9.2,8c0,0.7-0.6,1.2-1.2,1.2S6.8,8.7,6.8,8S7.3,6.8,8,6.8S9.2,7.3,9.2,8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.f495e3e062fb7b5ced1b70ff729a37ac.svg";
export { ForwardRef as ReactComponent };